import React from "react";
import PropTypes from 'prop-types';

import makePlayerEventTracker from "./playerEventsTracker";
import playerParams from "./playerParams";
import OoyalaApiClient from "../client/OoyalaApiClient";
import {ALL_OOYALA_EVENTS, VIDEO_HMTL_CREATED, VIDEO_STARTED} from "./PlayerEventNames";

export const PLAYER_WAS_STARTED = "SPL_PLAYER_WAS_STARTED";

export const playerManagerFactory = (playersMap, apiClient) => {
  return (WrappedComponent) => {
    return class extends React.Component {
      static contextTypes = {
        metrics: PropTypes.object
      }

      stopOtherPlayers = (containerId) => {
        Object.entries(playersMap)
          .filter(([key]) => {
            return key !== containerId
          })
          .forEach(([, value]) => {
            value.player.pause();
          })
      }

      notifyPlayerIsPlaying = (containerId) => () => {
        const event = new CustomEvent("SPL_PLAYER_WAS_STARTED", {
          detail: {containerId}
        });

        window.dispatchEvent(event)
      }

      createPlayer = (containerId, contentId, ooyala) => {
        if (!ooyala) {
          throw new Error("Can't create a player without reference to Ooyala plugin");
        }

        const createPlayer = new Promise((resolve) => {
          ooyala.ready(() => {
            const notifyPlayerIsPlaying = this.notifyPlayerIsPlaying(containerId);
            const createdPlayer = ooyala.Player.create(containerId, contentId, playerParams);

            const playerMapEntry = {
              player: createdPlayer,
            };

            playersMap[containerId] = playerMapEntry;

            createdPlayer.mb.subscribe(ALL_OOYALA_EVENTS , '', makePlayerEventTracker(this.context));

            createdPlayer.mb.subscribe(VIDEO_HMTL_CREATED, '', () => {
              // Play inline on iphone instead of full screen
              const containerElement = document.getElementById(containerId);
              const videoElements = containerElement && containerElement.getElementsByTagName('video');
              if (videoElements && videoElements.length === 1) {
                const videoElement = videoElements[0];
                videoElement && videoElement.setAttribute("webkit-playsinline", true)
                videoElement && videoElement.setAttribute("playsinline", true)
              }
            });

            createdPlayer.mb.subscribe(VIDEO_STARTED , '', () => {
              this.stopOtherPlayers(containerId);
              notifyPlayerIsPlaying();
            });

            resolve(playerMapEntry);
          });
        })

        const fetchMetadata = new Promise((resolve) => {
          apiClient.getAsset(contentId).then(assetData => {
            resolve(assetData)
          }).catch((error) => {
            console.log(`Failed to fetch metadata for Ooyala content ${contentId}`, error);
            resolve({})
          })
        });

        return Promise.all([createPlayer, fetchMetadata]).then(([player, metadata]) => {
          return {...player, metadata}
        })
      }

      removePlayer = (containerId) => {
        delete playersMap[containerId];
      }

      render() {
        return (
          <WrappedComponent
            createPlayer={this.createPlayer}
            removePlayer={this.removePlayer}
            {...this.props}
          />
        );
      }
    };
  }
}


export default playerManagerFactory({}, OoyalaApiClient);



// WEBPACK FOOTER //
// ./modules/Ooyala/component/withPlayerManager.js